<template>
    <div class="w-full px-4 flex justify-center">
        <footer class="bg-background-accent rounded-lg border border-background-accent-dark max-w-7xl flex self-center w-full mb-4">
            <div class="w-full mx-auto max-w-(--breakpoint-xl) p-4 md:flex md:items-center md:justify-between">
                <span class="text-sm text-text sm:text-center">
                    <a href="https://yipp.nl/" class="hover:underline">Yipp</a>. All Rights Reserved.
                </span>
                <div class="flex flex-col gap-0 items-center">
                    <div class="text-primary mt-3 md:mt-0">
                        Made with ♥ by Yipp
                    </div>
                    <div class="text-gray-400 text-xs">{{ get_version }}</div>

                </div>
                <ul class="flex flex-wrap items-center mt-3 text-sm font-medium text-text md:mt-0">
                    <li>
                        <NuxtLink
                            :to="localePath('/contact-support')"
                            class="mr-4 hover:underline md:mr-6"
                        >{{ t('contactSupport') }}</NuxtLink>
                    </li>
                    <!-- <li>
                        <a href="#" class="mr-4 hover:underline md:mr-6">yipp.nl</a>
                    </li>
                    <li>
                        <a href="#" class="mr-4 hover:underline md:mr-6">Licensing</a>
                    </li>
                    <li>
                        <a href="#" class="hover:underline">Contact</a>
                    </li> -->
                </ul>
            </div>
        </footer>
    </div>
</template>

<script lang="ts" setup>
const localePath = useLocalePath()
const { t } = useI18n({ useScope: 'local' })

const get_version = computed(() => {
    const config = useRuntimeConfig()
    // console.log(config.public)
    if (!config.public.version.tag) return `Version ${ config.public.version.commit_hash }`
    return `v${ config.public.version.tag } (${ config.public.version.commit_hash })`
})
</script>

<style scoped lang="scss">
footer {
    // padding-top: 1rem;
    // padding-bottom: 1rem;
    // border: 1px solid #ddd;
    // margin-top: 2rem;
    color: #666;
    font-size: 0.9rem;

    .version-text {
        color: #aaa;
        font-size: 0.7rem;
    }
}
</style>

<i18n lang="yaml">
en:
    contactSupport: Contact & Support
nl:
    contactSupport: Contact & Ondersteuning
</i18n>
